import { ASSET_TYPES } from 'utils/constants';
import { CONNECTOR_TYPES } from '../microgrid.constants';

export const getDefaultBatteryTemplate = ({ hasSecondInverter = false }) => {
  return {
    ratedActivePower: null,
    ratedApparentPower: 318,
    storageCapacity: null,
    label: 'Battery',
    isPrimary: false,
    connections: [
      {
        id: 'a',
        type: 'male',
        connectionType: 'source',
        connectorType: CONNECTOR_TYPES.POWER_LOCK,
        ratedCurrent: 400,
      },
      {
        id: 'b',
        type: 'female',
        connectionType: 'drain',
        connectorType: CONNECTOR_TYPES.POWER_LOCK,
        ratedCurrent: 400,
      },
      {
        id: 'c',
        type: 'female',
        connectionType: 'drain',
        connectorType: CONNECTOR_TYPES.POWER_LOCK,
        ratedCurrent: 400,
      },
      ...(hasSecondInverter
        ? [
            {
              id: 'd',
              type: 'male',
              connectionType: 'source_2',
              connectorType: CONNECTOR_TYPES.POWER_LOCK,
              ratedCurrent: 400,
            },
          ]
        : []),
    ],
  };
};

export const SOLAR_PANEL_TEMPLATE = {
  label: 'Solar panels',
  connections: [
    {
      id: 'a',
    },
    {
      id: 'b',
    },
    {
      id: 'c',
    },
  ],
};

export const WIND_TURBINE_TEMPLATE = {
  label: 'Wind turbines',
  connections: [
    {
      id: 'a',
    },
  ],
};

export const HYDROGEN_GENERATOR_TEMPLATE = {
  label: 'Hydrogen generator',
  connections: [
    {
      id: 'a',
      type: 'male',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: 400,
    },
    {
      id: 'b',
      type: 'female',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: 400,
    },
  ],
};

export const ELECTRICAL_SUBSTATION_TEMPLATE = {
  label: 'Electrical substation',
  connections: [
    {
      id: 'a',
      type: 'male',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: null,
    },
    {
      id: 'b',
      type: 'female',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
    {
      id: 'c',
      type: 'female',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
    {
      id: 'd',
      type: 'female',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
  ],
};

export const DIESEL_GENERATOR_TEMPLATE = {
  label: 'Diesel generator',
  connections: [
    {
      id: 'a',
      type: 'male',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: 400,
    },
    {
      id: 'b',
      type: 'female',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: 400,
    },
  ],
};

export const GRID_TEMPLATE = {
  ratedActivePower: null,
  label: 'Grid',
  connections: [
    {
      id: 'a',
    },
  ],
};

export const ENERGY_METER_TEMPLATE = {
  ratedCurrent: null,
  label: 'Energy Meter',
  connections: [
    {
      id: 'a',
      type: 'male',
      connectionType: 'source',
      connectorType: CONNECTOR_TYPES.ROGOWSKI_COIL,
    },
    {
      id: 'b',
      type: 'female',
      connectionType: 'drain',
      connectorType: CONNECTOR_TYPES.ROGOWSKI_COIL, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
    },
  ],
};

export const DISTRIBUTION_BOX_TEMPLATE = {
  label: 'Distribution Box',
  connections: [
    {
      id: '0',
      connectorType: CONNECTOR_TYPES.POWER_LOCK,
      ratedCurrent: null,
    },
    {
      id: '1',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
    {
      id: '2',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
    {
      id: '3',
      connectorType: CONNECTOR_TYPES.POWER_LOCK, //rogowski coil meters or current transformers are not part the the actual network and thus have no connectors.
      ratedCurrent: null,
    },
  ],
};

export const LOAD_TEMPLATE = {
  label: 'Default Load',
  connections: [
    {
      id: 'a',
      type: 'male',
      connectorType: null,
      ratedCurrent: null,
    },
  ],
};

export const NODE_TEMPLATES = {
  [ASSET_TYPES.GENERATOR]: DIESEL_GENERATOR_TEMPLATE,
  [ASSET_TYPES.ENERGY_METER]: ENERGY_METER_TEMPLATE,
  [ASSET_TYPES.GRID]: GRID_TEMPLATE,
  [ASSET_TYPES.DISTRIBUTION_BOX]: DISTRIBUTION_BOX_TEMPLATE,
  [ASSET_TYPES.LOAD]: LOAD_TEMPLATE,
  [ASSET_TYPES.ELECTRICAL_SUBSTATION]: ELECTRICAL_SUBSTATION_TEMPLATE,
  [ASSET_TYPES.HYDROGEN_GENERATOR]: HYDROGEN_GENERATOR_TEMPLATE,
  [ASSET_TYPES.SOLAR_PANEL]: SOLAR_PANEL_TEMPLATE,
  [ASSET_TYPES.WIND_TURBINE]: WIND_TURBINE_TEMPLATE,
};
